import React, { useContext, useEffect } from 'react'
import bg from 'images/icons/modal/bg.svg'
import { navigate } from 'gatsby'
import Checkmark from 'images/inline/modal/checkmark.svg'
import Lock from 'images/inline/lock-and-key.svg'
import './FormCompleted.scss'
import { modalContext } from 'global/context/sub-contexts/modalContext'
export default ({
  name = 'untitled',
  successText = '',
  isActive,
  children,
}) => {
  const modal_context = useContext(modalContext)
  const { showSignInModalTab } = modal_context || {}
  const goToSignIn = () => {
    navigate('/')
    showSignInModalTab()
  }

  useEffect(() => {
    //Make sure the container area is large enough for all of the elements inside it.
    document.querySelector('.form-success__container').style.minHeight =
      Math.max.apply(null, [
        document.querySelector('.form-success__success-state-container')
          .offsetHeight,
        document.querySelector('.form-success__content').offsetHeight,
      ]) + 'px'
  })

  return (
    <div
      className={`${
        isActive === true ? 'is--active' : 'is-not-active'
      } form-success__container name--${name}`}
    >
      {isActive}
      <div className="form-success__success-state">
        <div className="form-success__success-state-container">
          <div className="form-success__image">
            <div
              className="form-success__image-bg"
              style={{ backgroundImage: `url(${bg})` }}
            ></div>
            <div className="form-success__icon">
              {name === 'resetpw' ? <Lock /> : <Checkmark />}
            </div>
          </div>
          <div className="form-success__success-text">
            <h3>{successText}</h3>
            {name === 'resetpw' && (
              <button className="btn" onClick={goToSignIn}>
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="form-success__content">{children}</div>
    </div>
  )
}
